import {WixSdk} from '@wix/js-sdk-wrapper';

export {getInstanceId, getBiToken} from '@wix/music-shared/dist/src/utils/wix-utils';

function openPopupOrModal(opener: (cb: () => void) => void) {
  WixSdk.getBoundingRectAndOffsets().then((rectAndOffsets) => {
    const offsets = rectAndOffsets.offsets;
    const rect = rectAndOffsets.rect;

    function restoreScroll() {
      WixSdk.scrollTo(offsets.x, offsets.y - rect.top);
    }

    opener(restoreScroll);
  });
}

export function openPopup(
  path: string,
  width: string | number,
  height: string | number,
  callback: () => void,
  theme: any,
) {
  let opener = function (restoreScroll: () => void) {
    WixSdk.openPopup(
      path,
      width,
      height,
      {
        origin: WixSdk.WindowOrigin.FIXED,
        placement: WixSdk.WindowPlacement.CENTER,
      },
      theme,
    ).then(() => {
      callback();
      restoreScroll();
    });
  };

  if (WixSdk.Utils.getDeviceType() === 'mobile') {
    opener = function (restoreScroll) {
      WixSdk.openModal(path, width, height, theme).then((...args) => {
        callback();
        restoreScroll();
      });
    };
  }
  openPopupOrModal(opener);
}

export function openModal(
  path: string,
  width: string | number,
  height: string | number,
  callback: () => void,
  theme: any,
) {
  const opener = function (restoreScroll: () => void) {
    WixSdk.openModal(path, width, height, theme).then((...args) => {
      callback();
      restoreScroll();
    });
  };
  openPopupOrModal(opener);
}
